import type { UseFetchOptions } from '#app';

// UseFetch returns an object that mixes both the fetch promise and the reactive response data. So its usable even without awaiting the promise.
// It is only necessary to await the UseFetch if you need the data immediately after.
// Context:
// https://github.com/nuxt/nuxt/blob/main/packages/nuxt/src/app/composables/asyncData.ts#L407
// https://stackoverflow.com/questions/76863634/why-can-i-access-the-return-value-of-usefetch-without-await-keyword
export function useApiFetch<DataT>(url: MaybeRefOrGetter<string>, options: UseFetchOptions<ResponseDTO<DataT>> = {}) {
  // Plugin typing is currently broken: https://github.com/nuxt-modules/ionic/issues/597
  const appApiFetch = useNuxtApp().$appApiFetch as typeof $fetch;

  return useFetch<ResponseDTO<DataT>>(url, {
    ...options,
    $fetch: appApiFetch
  });
}

export function getAppApiFetch() {
  // Plugin typing is currently broken: https://github.com/nuxt-modules/ionic/issues/597
  return useNuxtApp().$appApiFetch as typeof $fetch;
}

export function useApiFetchAnonymous<DataT>(url: MaybeRefOrGetter<string>, options: UseFetchOptions<ResponseDTO<DataT>> = {}) {
  // Plugin typing is currently broken: https://github.com/nuxt-modules/ionic/issues/597
  const appApiFetch = useNuxtApp().$appApiFetchAnonymous as typeof $fetch;

  return useFetch<ResponseDTO<DataT>>(url, {
    ...options,
    $fetch: appApiFetch
  });
}

export function getAppApiFetchAnonymous() {
  // Plugin typing is currently broken: https://github.com/nuxt-modules/ionic/issues/597
  return useNuxtApp().$appApiFetchAnonymous as typeof $fetch;
}

export function getAppApiUpload() {
  return useNuxtApp().$appApiUpload as <T>(url: string, formData: FormData, onProgress: (ratio: number, total: number) => void) => Promise<T>;
}
